import React, { useState, useEffect, useRef } from "react";
import {
  Spin,
  Card,
  Col,
  Row,
  Typography,
  Space,
  Table,
  Tag,
  Input,
  Button,
  Switch,
  Checkbox,
  Form,
  notification,
  Popconfirm
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { cfs } from "../../../firebase/firebase";
import { groupBy, sortFunction } from "../../../utility";
import { CSVLink } from "react-csv";
import Highlighter from "react-highlight-words";
import AddAndEditProduct from "./addAndEditProduct";
import { blue } from "@ant-design/colors";
import { IItem } from "../../../models/Item";
import { IChoiceGroup } from "../../../models/choiceGroup";
const { Title } = Typography;

// const handleUpdateProduct = () => {
//   let batch = cfs.batch();
//   console.log("products", products);
//   products.forEach((item, index, array) => {
//     const ref = cfs
//       .collection("merchants")
//       .doc(`${currentUser.merchantId}`)
//       .collection("products")
//       .doc(`${item.itemId}`);
//     batch.update(ref, {
//       isSuggest: false,
//       isProductClose: false,
//     });
//     if (array.length - 1 === index) {
//       batch
//         .commit()
//         .then((batchUpdate) => {
//           console.log("update ข้อมูลแล้วจ้า : ", batchUpdate);
//         })
//         .catch((e) => {
//           console.log(e.message);
//         });
//     }
//   });
// };

const headers = [
  { label: "ลำดับ", key: "no" },
  { label: "รหัสสินค้า", key: "itemId" },
  { label: "รายการ", key: "itemName" },
  { label: "ราคา", key: "price" },
  { label: "ประเภท", key: "category" },
  { label: "เมนูแนะนำ", key: "isSuggest" },
  { label: "เปิดขาย", key: "isProductClose" },
];

const ProductTab = ({ currentUser }: any) => {
  const searchInput = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [modalType, setModalType] = useState<string>("add");
  const [tmpData, setTmpData] = useState<IItem>({
    productId: "",
    itemName: "",
    price: 0,
    category: "",
    imageUrl: "",
    options: [],
    choices: [],
  });
  const [open, setOpen] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [products, setProducts] = useState<IItem[]>([]);
  const [rowSelection, setRowSelection] = useState<any>([]);
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [choiceGroups, setChoiceGroups] = useState<IChoiceGroup[]>([]);

  useEffect(() => {
    let unsubscribe: any;
    if (currentUser.merchantId) {
      unsubscribe = cfs
        .collection("/merchants")
        .doc(`${currentUser.merchantId}`)
        .collection("products")
        .onSnapshot({
          next: async (snapshot) => {
            if (snapshot.size) {
              let tmpProducts: any = await Promise.all(
                snapshot.docs.map(async (item) => {
                  return { ...item.data(), id: item.id };
                })
              );
              tmpProducts = tmpProducts.sort((a: any, b: any) =>
                sortFunction(a, b, "category")
              );
              tmpProducts = tmpProducts.map((item: any, index: number) => ({
                ...item,
                no: index + 1,
              }));
              // console.log("tmpProducts :>> ", tmpProducts);
              setProducts(tmpProducts);
              setLoading(false);
            } else {
              // it's empty
              setProducts([]);
              setLoading(false);
            }
          },
          error: (error) => {
            console.log(error);
            setError(error.message);
            setLoading(false);
          },
        });
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [currentUser.merchantId]);

  useEffect(() => {
    let unsubscribe: any;

    if (currentUser.merchantId) {
      unsubscribe = cfs
        .collection("/merchants")
        .doc(`${currentUser.merchantId}`)
        .collection("choiceGroups")
        .onSnapshot({
          next: async (snapshot) => {
            if (snapshot.size) {
              let tmpChoicesGroups: any = await Promise.all(
                snapshot.docs.map(async (item, index) => {
                  let data = item.data();
                  return {
                    ...data,
                  };
                })
              );

              setChoiceGroups(tmpChoicesGroups);
            } else {
              // it's empty
              setChoiceGroups([]);
            }
          },
          error: (error) => {
            console.log(error);
            setError(error.message);
          },
        });
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [currentUser.merchantId]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: error,
        placement: "bottomRight",
        onClick: () => {
          setError("");
        },
      });
    }
  }, [error]);

  const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
    confirm();
    setSearchText(selectedKeys[0] ? selectedKeys[0].trim() : "");
    setSearchedColumn(dataIndex ? dataIndex.trim() : "");
  };

  const handleReset = (clearFilters: any) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`ค้นหา`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(
              e.target.value ? [e.target.value.toLowerCase()] : []
            )
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            ค้นหา
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            ล้าง
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase().trim())
        : "",
    onFilterDropdownVisibleChange: (visible: any) => {
      if (visible) {
        setTimeout(() => {
          searchInput.current.focus();
        }, 100);
      }
    },
    render: (text: string) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const categoryFilter = () => {
    let tmpCategory = Object.keys(groupBy(products, "category")).map(
      (item) => ({
        text: item,
        value: item,
      })
    );
    // console.log("tmpCategory", tmpCategory);
    return tmpCategory;
  };

  const handleDeleteProduct = (product: IItem) => {
    setLoading(true);
    cfs
      .collection("merchants")
      .doc(`${currentUser.merchantId}`)
      .collection("products")
      .doc(product.productId)
      .delete()

      .then((data) => {
        console.log("delete : ", data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error : ", error);
        setError(error.message);
      });
  };

  const handleCloseAdd = () => {
    setOpen(false);
    setTmpData({
      productId: "",
      itemName: "",
      price: 0,
      category: "",
      imageUrl: "",
      options: [],
      choices: [],
    });
  };

  // console.log("categoryFilter", categoryFilter());
  // console.log("products", products);

  const columns: any = [
    {
      title: "ลำดับ",
      dataIndex: "no",
      key: "no",
      align: "center",
      width: 50,
      // onFilter: (value, record) => record.itemId.indexOf(value) === 0,
      sorter: (a: any, b: any) => sortFunction(a, b, "no"),
    },
    // {
    //   title: "รหัสสินค้า",
    //   dataIndex: "itemId",
    //   key: "itemId",
    //   onFilter: (value, record) => record.itemId.indexOf(value) === 0,
    //   sorter: (a, b) => sortFunction(a, b, "itemId"),
    // },
    {
      title: "เมนูแนะนำ",
      align: "center",
      key: "isSuggest",
      width: 120,
      dataIndex: "isSuggest",
      filters: [
        {
          text: "เมนูแนะนำ",
          value: true,
        },
        {
          text: "เมนูปกติ",
          value: false,
        },
      ],
      onFilter: (value: any, record: any) => {
        return record.isSuggest === value;
      },
      render: (isSuggest: boolean, record: any) => (
        <Checkbox
          checked={isSuggest}
          // disabled
          onClick={() => handleSuggest(record)}
        />
      ),
      sorter: (a: any, b: any) => sortFunction(a, b, "isSuggest"),
    },
    {
      title: "รายการ",
      dataIndex: "itemName",
      key: "itemName",
      width: 250,
      ...getColumnSearchProps("itemName"),
      sorter: (a: any, b: any) => sortFunction(a, b, "itemName"),
    },
    {
      title: "ราคา",
      dataIndex: "price",
      key: "price",
      width: 100,
      align: "center",
      onFilter: (value: any, record: any) => record.price.indexOf(value) === 0,
      sorter: (a: any, b: any) => sortFunction(a, b, "price"),
    },
    {
      title: "ประเภท",
      align: "center",
      key: "category",
      dataIndex: "category",
      width: 100,
      render: (category: any, record: any, index: number) => (
        <Tag color={blue.primary}>{category}</Tag>
      ),
      filters: categoryFilter(),
      onFilter: (value: any, record: any) => {
        let filter = value ? record.category.indexOf(value) === 0 : false;
        return filter;
      },
      sorter: (a: any, b: any) => sortFunction(a, b, "category"),
    },
    {
      title: "เปิดขาย",
      align: "center",
      key: "active",
      dataIndex: "active",
      width: 100,
      filters: [
        {
          text: "เปิดขาย",
          value: false,
        },
        {
          text: "ปิดขาย",
          value: true,
        },
      ],
      onFilter: (value: any, record: any) => {
        return record.active === value;
      },
      render: (active: boolean, record: any) => (
        <Switch
          size="small"
          // disabled
          checked={active === true || active === undefined ? true : false}
          onClick={() => handleChangeActive(record)}
        />
      ),
      sorter: (a: any, b: any) => sortFunction(a, b, "active"),
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      render: (text: any, record: IItem) => (
        <Space size="middle">
          <a
            onClick={() => {
              setTmpData(record);
              setModalType("edit");
              setOpen(true);
            }}
          >
            แก้ไข
          </a>
          <Popconfirm
            title="คุณต้องการลบรายการนี้ออก?"
            onConfirm={() => handleDeleteProduct(record)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <a href="#">ลบ</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleSuggest = (record: any) => {
    // console.log("handleSuggest : ", record);
    setLoading(true);
    cfs
      .collection("merchants")
      .doc(currentUser.merchantId)
      .collection("products")
      .doc(`${record.productId}`)
      .update({
        isSuggest: !record.isSuggest,
      })
      .then((d) => {
        console.log(`update ${record.productId} ${record.itemName}`);
        setError("");
        setLoading(false);
      })
      .catch((e) => {
        console.log(e.message);
        setError(e.message);
        setLoading(false);
      });
  };

  const handleChangeActive = (record: any) => {
    console.log("handleChangeActive : ", record);
    cfs
      .collection("merchants")
      .doc(currentUser.merchantId)
      .collection("products")
      .doc(record.id)
      .update({
        active: record.active === undefined ? false : !record.active,
      })
      .then((d) => {
        console.log(`update ${record.id} ${record.itemName}`);
        setError("");
        setLoading(false);
      })
      .catch((e) => {
        console.log(e.message);
        setError(e.message);
        setLoading(false);
      });
  };

  const onChange = (
    pagination: any,
    filters: any,
    sorter: any,
    action: any
  ) => {
    console.log("params", pagination, filters, sorter, action);
    setPageSize(pagination.pageSize);
  };

  return (
    <Spin tip="กำลังโหลดข้อมูล.." spinning={loading}>
      <div>
        {/* <Form.Provider
          onFormFinish={(name, { values, forms }) => {
            console.log("x1 : ", values);
            if (name === "addProduct") {
              console.log("x2 : ", forms);
              const { addProduct } = forms;
              console.log("addProduct", addProduct);
              // const users = basicForm.getFieldValue("users") || [];
              // basicForm.setFieldsValue({ users: [...users, values] });
              setOpen(false);
            }
          }}
        > */}
        {open && (
          <AddAndEditProduct
            currentUser={currentUser}
            choiceGroups={choiceGroups}
            open={open}
            modalType={modalType}
            tmpData={tmpData}
            categoryList={categoryFilter()}
            handleClose={handleCloseAdd}
            products={products}
          />
        )}
        {/* </Form.Provider> */}
      </div>
      <Table
        bordered
        title={() => (
          <Row
            justify="space-between"
            //  justify="end"
          >
            <Col>
              <Title level={5}>ตารางรายการสินค้า</Title>
            </Col>
            <Col>
              <CSVLink
                data={products}
                headers={headers}
                filename={"ตารางรายการสินค้า.csv"}
                // className="ant-btn ant-btn-primary ant-btn-background-ghost"
                // className="ant-btn ant-btn-primary"
                className="ant-btn ant-btn-link"
                target="_blank"
              >
                บันทึกเป็น CSV
              </CSVLink>
              <Button
                // disabled
                type="primary"
                onClick={() => {
                  setModalType("add");
                  setOpen(true);
                }}
              >
                เพิ่มสินค้า
              </Button>
            </Col>
          </Row>
        )}
        onChange={onChange}
        columns={columns}
        dataSource={products}
        rowKey="no"
        pagination={{
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "30"],
          showSizeChanger: true,
        }}
        scroll={{ y: "100%", x: "max-content" }}
      />

      {/* <List
            itemLayout="vertical"
            size="large"
            pagination={{
              onChange: (page) => {
                console.log(page);
              },
              pageSize: 3,
            }}
            dataSource={products}
            header={
              <div>
                <b>จัดการสินค้า</b> <span>sdf</span>
              </div>
            }
            renderItem={(item) => (
              <List.Item
                key={item.title}
                actions={[
                  <Space>
                    <StarOutlined />
                    {`แนะนำ`}
                  </Space>,
                  <Space>
                    <CloseOutlined />
                    {`สินค้าหมด`}
                  </Space>,
                ]}
                extra={
                  <Image
                    width={120}
                    src="error"
                    fallback="data:image/png;base64,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"
                  />
                }
              >
                <List.Item.Meta
                  title={<a href="#">{item.itemName}</a>}
                  description={`ประเภท: ${item.category} ราคา: ${item.price}`}
                />
                {`รายละเอียดเพิ่มเติม :`}
              </List.Item>
            )}
          /> */}
    </Spin>
  );
};

export default ProductTab;
